/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 喉鏡
 */
export type TreatmentAirwayManagementLaryngoscopyEnum =
  (typeof TreatmentAirwayManagementLaryngoscopyEnum)[keyof typeof TreatmentAirwayManagementLaryngoscopyEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentAirwayManagementLaryngoscopyEnum = {
  DIRECT: 'DIRECT',
  VIDEO: 'VIDEO',
} as const;
